import event from '../utils/event'

export const getClcGroupSelect = () => event.get('/MarriageGrowth/GetClcGroupSelect')

export const getEventDesc = (data) => event.post('/MarriageGrowth/GetEventDesc', data)

export const getIdentityType = () => event.get('/MarriageGrowth/GetIdentityType')

export const checkSerialNumberText = (data) => event.post('/MarriageGrowth/CheckSerialNumberText', data)

export const getMarriageGrowth = (data) => event.post('/MarriageGrowth/GetMarriageGrowth', data)

export const getMarriageGrowthOuter = (data) => event.post('/MarriageGrowth/GetMarriageGrowthOuter', data)

export const sendMarriageGrowth = (data) => event.post('/MarriageGrowth/SendMarriageGrowth', data)

export const sendMarriageGrowthOuter = (data) => event.post('/MarriageGrowth/SendMarriageGrowthOuter', data)
